export const isProd = window.location.hostname === 'falcon.arzoopro.com';
export const isTest = window.location.hostname === 'test-supplier.arzooo.com';
export const isDev = window.location.hostname === 'localhost';
export const arzoooS3Url = isProd
  ? 'https://arzooo-static-prod-v2.s3.ap-south-1.amazonaws.com'
  : 'https://arzooo-static-prod-v2-dev.s3.ap-south-1.amazonaws.com';
